import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

const ProgressBar = ({ progress, visible }) => {
  return (
    <CSSTransitionGroup
      transitionName='aw_logo'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      {visible &&
        <div className='aw_progress-bar'>
          <div className='aw_progress-bar__bar' style={{ transform: `scaleX(${progress})` }} />
        </div>
      }
    </CSSTransitionGroup>
  )
}

ProgressBar.defaultProps = {
  progress: 0
}

ProgressBar.propTypes = {
  progress: PropTypes.number,
  visible: PropTypes.bool
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/templates/app-website/components/fixed/ProgressBar.js